import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=4760d0c2&"
import script from "./Thankyou.vue?vue&type=script&lang=js&"
export * from "./Thankyou.vue?vue&type=script&lang=js&"
import style0 from "./Thankyou.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports